import React from "react";
import styled from "styled-components";
import { ReactComponent as NewIcon } from "./icons/new.svg";
import { ReactComponent as InProgressIcon } from "./icons/inProgress.svg";
import { ReactComponent as ResolvedIcon } from "./icons/resolved.svg";
import { ReactComponent as RejectedIcon } from "./icons/rejected.svg";
import { ReactComponent as RecommendedIcon } from "./icons/recommended.svg";
import { FeatureRequestState } from "interfaces/feature-request";
import useTranslate from "hooks/common/useTranslate/useTranslate";

interface TagProps {
    textColor: string;
    backgroundColor: string;
    borderColor: string;
    translationKey: string;
}

interface StateConfig extends TagProps {
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

export const STATE_CONFIG: Record<FeatureRequestState, StateConfig> = {
    NEW: {
        textColor: "#0A4A5C",
        backgroundColor: "#E8F8FC",
        borderColor: "#A3E3F5",
        icon: NewIcon,
        translationKey: "featureRequests.state.NEW",
    },
    PENDING: {
        textColor: "#0A4A5C",
        backgroundColor: "#E8F8FC",
        borderColor: "#A3E3F5",
        icon: NewIcon,
        translationKey: "featureRequests.state.PENDING",
    },
    IN_PROGRESS: {
        textColor: "#634003",
        backgroundColor: "#FEF5E6",
        borderColor: "#FCD99C",
        icon: InProgressIcon,
        translationKey: "featureRequests.state.IN_PROGRESS",
    },
    REJECTED: {
        textColor: "#992400",
        backgroundColor: "#FFEBE5",
        borderColor: "#FFB199",
        icon: RejectedIcon,
        translationKey: "featureRequests.state.REJECTED",
    },
    RECOMMENDED: {
        textColor: "#3B590D",
        backgroundColor: "#F4FCE9",
        borderColor: "#BEEC79",
        icon: RecommendedIcon,
        translationKey: "featureRequests.state.RECOMMENDED",
    },
    RESOLVED: {
        textColor: "#3B590D",
        backgroundColor: "#F4FCE9",
        borderColor: "#BEEC79",
        icon: ResolvedIcon,
        translationKey: "featureRequests.state.RESOLVED",
    },
};

const StyledTag = styled.div<TagProps>`
    border-radius: 12px;
    background-color: ${(props) => props.backgroundColor};
    border: 1px solid ${(props) => props.borderColor};
    color: ${(props) => props.textColor};
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 1px 12px;
    font-size: 14px;
    font-weight: 400;

    svg {
        width: 14px;
        height: 14px;
        flex-shrink: 0;
    }

    &:not(:last-child) {
        margin-right: 0.5rem;
    }
`;

interface TagComponentProps extends TagProps {
    children?: React.ReactNode;
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    translationKey: string;
}

const Tag = ({ children, icon: IconComponent, ...props }: TagComponentProps) => {
    const translate = useTranslate();

    return (
        <StyledTag {...props}>
            <IconComponent />
            {translate(props.translationKey)}
        </StyledTag>
    );
};

export default Tag;
